<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
    </base-header>
    <b-container fluid class="mt--7">   
      <div class="mt-5"></div>
      <card>
        <report-process-view />
      </card>
      <location-report-table />
      
    </b-container>
  </div>
</template>

<script>
import ReportProcessView from './components/ReportProcessView.vue';

import LocationReportTable from '@/views/Tables/LocationReportTable.vue'

export default {
    components:{
        [LocationReportTable.name]:LocationReportTable,
        [ReportProcessView.name]:ReportProcessView,
    }

}
</script>

<style>

</style>